import React from "react";
import { getPeriods, getUnavailabilityOn, getQuotaOn, localIsoDate, fmtShort } from "../utils/availability";

const STYLES = {
  FULL: { cls: "bg-red-100 text-red-800", label: "🚫 FULL" },
  ON_LEAVE: { cls: "bg-amber-100 text-amber-800", label: "🌴 EN CONGÉS" },
  QUOTA: { cls: "bg-blue-100 text-blue-800" },
  AVAILABLE: { cls: "bg-emerald-100 text-emerald-800", label: "✅ Dispo" },
};

/**
 * Badge du statut de disponibilité du jour (périodes FULL / EN CONGÉS, quota).
 */
export const AvailabilityBadge = ({ employee, size = "sm", date }) => {
  const today = date || localIsoDate();
  const base = size === "xs" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs";
  const current = getUnavailabilityOn(employee, today);
  const upcoming = getPeriods(employee).filter((p) => p.start_date && p.start_date > today);
  const upcomingTxt = upcoming.length
    ? ` — À venir : ${upcoming.map((p) => `${p.type === "FULL" ? "FULL" : "Congés"} ${fmtShort(p.start_date)}→${fmtShort(p.end_date)}`).join(", ")}`
    : "";

  let key = "AVAILABLE";
  let label = STYLES.AVAILABLE.label;
  let title = `Disponible${upcomingTxt}`;
  if (current) {
    key = current.type;
    const periodTxt = current.start_date || current.end_date ? ` (${fmtShort(current.start_date)} → ${fmtShort(current.end_date)})` : "";
    label = (
      <>
        {STYLES[key].label}
        {periodTxt && <span className="opacity-70 ml-0.5 hidden sm:inline">{periodTxt}</span>}
      </>
    );
    title = `${key === "FULL" ? "Indisponible" : "En congés"}${periodTxt}${upcomingTxt}`;
  } else {
    const quota = getQuotaOn(employee, today);
    if (quota) {
      key = "QUOTA";
      label = `⚡ Max ${quota}/j`;
      title = `Maximum ${quota} missions par jour${upcomingTxt}`;
    }
  }

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold ${STYLES[key].cls} ${base}`}
      data-testid={`availability-badge-${key}`}
      title={title}
    >
      {label}
      {upcoming.length > 0 && <span className="opacity-70">📅</span>}
    </span>
  );
};

export default AvailabilityBadge;
